import { useSuspenseQueries } from '@tanstack/react-query';
import { getBrokersOptions } from '../../shared/broker/brokers/queryOptions';
import { getTeamsOptions } from '../../shared/team/teams/queryOptions';

export function useGetFilterOptionData() {
  const [{ data: brokers }, { data: teams }] = useSuspenseQueries({
    queries: [getBrokersOptions(), getTeamsOptions()],
  });

  return { brokers: brokers.response, teams: teams.response };
}
